import { InsuranceType } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";

@Entity('insurance')
export class Insurance {

  @PrimaryGeneratedColumn("increment",{name:'insurance_id'})
  insuranceId:number;
  
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"company_name"
      })
  companyName:string;

  @Column("varchar",{
      nullable: true,
      length:40,
      name:"email_id"
      })
      emailId:string;

      @Column("varchar",{
        nullable: true,
        length:20,
        name:"mobile_number"
        })
        mobileNumber:string;
    @Column("enum",{
        nullable: true,
        enum:InsuranceType,
        default:InsuranceType.Internal,
        name:"insurance_type"
        })
        insuranceType:InsuranceType;
  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;
}
